












































































































































































import {
  defineComponent, reactive, computed, ref, onMounted, watch,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';
import _ from 'lodash';
import PrettyCheck from 'pretty-checkbox-vue/check';

import user from '@/table/user';

import useAuth from '@/useAuth';

import CommonFormWithRoleEditor from '@/components/User/CommonFormWithRoleEditor.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import NotFound from '@/components/NotFound.vue';

import {
  getUsers,
  deleteUser,
  deleteUsers,
  getRoles,
  createRole,
  deleteRole,
  activateVisitor,
  getVisitorPin,
  updateUserRole,
} from '@/api/index';

const List = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
    CommonFormWithRoleEditor,
    NotFound,
  },
  props: {
    role: {},
  },
  setup() {
    const { route, router } = useRouter();

    const {
      // me,
      hasPermission,
    } = useAuth();

    // ==== This section use with ROLE ====
    const roles = ref([]);
    const roleLoading = ref(true);
    const createRoleModal = ref(null);
    const callGetRoles = async () => {
      roleLoading.value = true;
      const data = await getRoles();
      roles.value = data.map((elm: any) => ({ ...elm }));
      roleLoading.value = false;
    };
    const editRoleId = ref(-1);
    const formCreate = reactive({
      name: '',
      call: async () => {
        await createRole(formCreate.name);
        (createRoleModal.value as any).close();
        await callGetRoles();
        formCreate.name = '';
      },
      state: {
        value: 'READY',
      },
    });
    const deleteRoleAction = async (id: number) => {
      const result = await deleteRole(id);
      await callGetRoles();
    };
    const getRoleDisplayFromRoute = computed(() => roles.value.find((elm: any) => elm.id === route.value.params.roleId));

    onMounted(async () => {
      await callGetRoles();
    });
    // ==========================================

    // ==== This section use with USER Table ====
    const loading = ref(true);
    const users = ref([]);
    const pagination = ref({
      // eslint-disable-next-line
      current_page: 1,
    });
    const page = ref(1);
    const sort = ref({ field: 'created_at', order: 'ASC' });

    const from = ref('');
    const to = ref('');
    const searchString = ref('');
    const searchStatus = ref('');

    const callGetUsers = async () => {
      loading.value = true;
      const { data, ...paginatorData } = await getUsers(
        page.value,
        30,
        sort.value,
        route.value.params.roleId,
        searchString.value,
      );
      users.value = data.map((elm: any) => ({ ...elm, _secondaryControls: false }));
      pagination.value = paginatorData;
      loading.value = false;
    };

    watch(() => route.value.params.roleId, async (newVal) => {
      // eslint-disable-next-line
      if (newVal) {
        await callGetUsers();
      }
    });

    const pendingSearch = _.debounce(async () => {
      page.value = 1;
      await callGetUsers();
    }, 500);

    watch(() => page.value, async (newVal) => {
      // eslint-disable-next-line
      if (newVal !== pagination.value.current_page) {
        await callGetUsers();
      }
    });
    const handleSortChange = (sortParam: { field: string; order: string }) => {
      sort.value = sortParam;
    };
    watch(() => sort.value, async (newVal, oldVal) => {
      // eslint-disable-next-line
      if (newVal !== oldVal) {
        await callGetUsers();
      }
    });

    const setActiveStatus = async (id: number, status: boolean) => {
      const index = users.value.findIndex((elm: any) => elm.id === id);
      await activateVisitor(id, !(users.value[index] as any).active);
      (users.value[index] as any).active = !(users.value[index] as any).active;
    };

    // ==================== //
    // Use with select item //
    const selectedItems: number[] = reactive([]);
    const selectItem = (id: number, status: boolean) => {
      if (status) {
        const removeIndex = selectedItems.findIndex((elm: any) => elm === id);
        if (removeIndex > -1) selectedItems.splice(removeIndex, 1);
      } else {
        selectedItems.push(id);
      }
      const index = users.value.findIndex((elm: any) => elm.id === id);
      (users.value[index] as any)._secondaryControls = !status;
    };
    const selectAllItems = () => {
      if (selectedItems.length > 0) selectedItems.splice(0, selectedItems.length);
      users.value.forEach((elm: any, index: number) => {
        (users.value[index] as any)._secondaryControls = true;
        selectedItems.push(elm.id);
      });
    };
    const unselectAllItems = () => {
      selectedItems.splice(0, selectedItems.length);
      users.value.forEach((elm: any, index: number) => {
        (users.value[index] as any)._secondaryControls = false;
      });
    };

    // =================== DELETE FUNCTION ======================
    // Delete dialog
    const deleteUserModal = ref(null);
    const deleteUsersModal = ref(null);
    // ==== Delete Users ==== //
    const deleteUserAction = async (id: number) => {
      const result = await deleteUser([id]);
      await callGetUsers();
    };
    const deleteUsersAction = async () => {
      const result = await deleteUsers(selectedItems);
      await callGetUsers();
    };
    function openDeleteUserModal(item: any) {
      (deleteUserModal.value as any).compose({
        id: parseInt(item.id, 10),
        action: 'ลบ',
        entity: 'ผู้ใช้งาน',
        body: `เป็นการลบ<br>${item.name}<br>จากระบบโดยถาวร<br>ไม่สามารถย้อนคืนได้`,
      });
    }

    // ==== Use Format ==== //
    function useDateTimeFormat(date: any) {
      if (!date) return '';
      return `${useFormat.date(date).displayShortThaiDate()} เวลา ${date.substring(11, 16)}`;
    }

    const showPinModal = ref(null);
    const singleUser = reactive({
      pin: '',
    });
    async function getVisitorPinAction(id: number) {
      const { data } = await getVisitorPin(id);
      singleUser.pin = data.new_pin;
      (showPinModal.value as any).open();
    }

    async function changeRoleHandler(id: number, role: number | string) {
      await updateUserRole(id, [role] as any);
      await callGetUsers();
    }

    return {
      getRoleDisplayFromRoute,
      hasPermission,

      createRoleModal,
      formCreate,
      roles,
      editRoleId,

      userTableOption: user,

      useDateTimeFormat,

      users,
      page,
      pagination,
      loading,
      searchString,
      searchStatus,
      from,
      to,

      pendingSearch,

      sort,
      handleSortChange,

      setActiveStatus,

      selectItem,
      selectAllItems,
      selectedItems,
      unselectAllItems,

      deleteUserModal,
      deleteUsersModal,
      deleteUserAction,
      deleteUsersAction,
      openDeleteUserModal,

      deleteRoleAction,

      showPinModal,
      getVisitorPinAction,
      singleUser,
      changeRoleHandler,
    };
  },
});

export default List;
